import { useRef } from 'react';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';

export default function HotLeaksSection() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const amount = 340;
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth',
    });
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-black text-foreground-950">
              热门<span className="text-primary-500"> 爆料</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              网红反差视频、博主私下爆料、明星聊天记录泄露
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="px-3 py-1.5 text-[11px] font-semibold bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
              实时更新
            </span>
            <button
              onClick={() => scroll('left')}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 hover:bg-background-200 text-foreground-600 transition-colors cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 hover:bg-background-200 text-foreground-600 transition-colors cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto scrollbar-hide pb-2 -mx-4 md:-mx-6 lg:-mx-10 px-4 md:px-6 lg:px-10"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {articles.map((article) => (
            <div key={article.id} className="w-[280px] shrink-0">
              <ArticleCard article={article} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}